import { Badge } from '@/ui'

type BadgeColor = 'gray' | 'blue' | 'green' | 'red' | 'yellow'

const STATUS_MAP: Record<string, BadgeColor> = {
  // 대문자 (레거시)
  PENDING: 'yellow',
  PROCESSING: 'blue',
  COMPLETED: 'green',
  FAILED: 'red',
  REFUNDED: 'gray',
  PREMIUM_UPGRADE: 'blue',
  AI_CREDITS: 'green',
  AI_CREDITS_BUNDLE: 'green',
  PREMIUM: 'blue',
  FREE: 'gray',
  ADMIN: 'red',
  USER: 'gray',
  PUBLISHED: 'green',
  DEDUCT: 'red',
  REFUND: 'blue',
  PURCHASE: 'green',
  BONUS: 'yellow',
  // 소문자 (통합 활동 히스토리)
  pending: 'yellow',
  processing: 'blue',
  completed: 'green',
  partial: 'yellow',
  failed: 'red',
  cancelled: 'gray',
}

interface StatusBadgeProps {
  status: string
  label?: string
  className?: string
}

export function StatusBadge({ status, label, className }: StatusBadgeProps) {
  const color = STATUS_MAP[status] ?? 'gray'
  return <Badge color={color} className={className}>{label ?? status}</Badge>
}
